import { getMetricsChart } from '@/services/dashboard-service/dashboard.service';
import { CallMetricsChartParams } from '@/services/dashboard-service/dashboard.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export const useMetricsChart = (params: CallMetricsChartParams) => {
  const {
    data: metricsChartData,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.METRICS_CHART(params),
    queryFn: () => getMetricsChart(params),
    enabled: !!params.chart_params,
  });
  return { metricsChartData, error, isLoading, refetch };
};
